import React, { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
const names = ['Juan', 'María', 'Martín', 'Lucía', 'Diego', 'Sofía', 'Javier', 'Valeria', 'Facundo', 'Camila'];
const cities = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Neuquén', 'Salta', 'Tucumán', 'Santa Fe'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 3000);
    // Then show randomly every 15-25 seconds
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 10000) + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 right-4 md:right-auto md:w-80 bg-white rounded-lg shadow-xl border border-gray-100 p-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500 flex items-start gap-3" data-id="element-1">
      <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-2">
        <MapPin className="w-5 h-5 text-green-600" data-id="element-3" />
      </div>
      <div data-id="element-4">
        <p className="text-sm text-gray-800" data-id="element-5">
          <span className="font-bold" data-id="element-6">{currentData.name}</span> de{' '}
          {currentData.city}
        </p>
        <p className="text-xs text-gray-500 mt-1" data-id="element-7">
          Acaba de comprar este libro digital
        </p>
        <p className="text-xs text-green-600 font-medium mt-1" data-id="element-8">
          Hace unos minutos
        </p>
      </div>
    </div>;
}